import api from "./api";

// Get a signed Cloudinary upload signature from the backend
export async function getCloudinarySignature(folder = "lis/logo") {
  const res = await api.post("/uploads/cloudinary-signature", { folder });
  return res.data.data;
}

// Upload a file to Cloudinary using a signed signature
export async function uploadLogoToCloudinarySigned(file) {
  // 1. Get signature from backend
  const sig = await getCloudinarySignature();
  const formData = new FormData();
  formData.append("file", file);
  formData.append("api_key", sig.apiKey);
  formData.append("timestamp", sig.timestamp);
  formData.append("signature", sig.signature);
  if (sig.folder) formData.append("folder", sig.folder);

  const url = `https://api.cloudinary.com/v1_1/${sig.cloudName}/image/upload`;
  const response = await fetch(url, {
    method: "POST",
    body: formData,
  });
  if (!response.ok) throw new Error("Failed to upload image to Cloudinary");
  const data = await response.json();
  return data.secure_url;
}
